import { CHANGE_ROUND_TABLES_FILTER } from '../actions/actionTypes';


function roundTablesFilterSelector(state = '', action) {
  switch (action.type) {
    case CHANGE_ROUND_TABLES_FILTER:
      return action.newFilter;
    default:
      return state;
  }
}

export default roundTablesFilterSelector;



/** WEBPACK FOOTER **
 ** ./src/reducers/roundTablesFilterSelector.js
 **/